import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MainContent } from '../components/layout/MainContent';

export const HomePage: React.FC = () => {
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "SleepCalc Pro",
    "description": "Advanced sleep calculator and bedtime optimizer that helps users calculate optimal sleep times based on sleep cycles",
    "url": "https://sleepcalc-pro.pages.dev",
    "applicationCategory": "HealthApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free sleep calculator with premium features available"
    },
    "author": {
      "@type": "Organization",
      "name": "SleepCalc Pro Team"
    },
    "featureList": [
      "Sleep cycle calculation",
      "Optimal bedtime recommendations", 
      "Wake-up time optimization",
      "AI-powered sleep insights",
      "Moon phase tracking",
      "Circadian rhythm analysis"
    ]
  };

  return (
    <>
      <Helmet>
        <title>SleepCalc Pro - Advanced Sleep Calculator & Bedtime Optimizer</title>
        <meta name="description" content="Calculate optimal sleep times with our advanced sleep cycle calculator. Get personalized bedtime recommendations, wake-up times, and AI-powered sleep insights to improve your sleep quality naturally." />
        <meta name="keywords" content="sleep calculator, bedtime calculator, wake up time calculator, sleep cycle calculator, sleep optimization, optimal sleep time, circadian rhythm, REM sleep, deep sleep, sleep quality" />
        <link rel="canonical" href="https://sleepcalc-pro.pages.dev/" />
        <script type="application/ld+json">
          {JSON.stringify(homeStructuredData)}
        </script>
      </Helmet>
      <MainContent />
    </>
  );
};